<style>
    /* background properties for both real image and loader */
    .background, .background-loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        transition: all 1.5s;
        background-position: center center;
        z-index: -1;
    }

    /* base state of real background (hide at first) */
    .background {
        opacity: 0;
        //transition: all 1.5s;
    }

    .background.parallax {
        background-attachment: fixed;
    }

    /* once its loaded, show */
    .background.loaded {
        opacity: 1;
        //transition: all 1.5s;
    }

    /*                                    */
    .background-loader {
        opacity: 1;
        transition-duration: 1.5s;
        transition-delay: 1s;
        transition-property: opacity;
    }

    /*                                     */
    .background-loader.loaded {
        transition-duration: 1.5s;
        transition-delay: 1s;
        transition-property: opacity;
        opacity: 0;
    }
</style>

<script>
    import { onMount } from 'svelte';
    import Util from "../lib/util.js";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    //
    // bindings
    //

    export let content = "darken";
    export let random = false;
    export let parallax = true;
    export let enable = true;

    // parameters for scaling Unsplash
    export let quality = 80;
    export let width;
    export let height;
    export let loaderBackground = "#fff";
    export let loader = true;

    // work & business related images from Unsplash
    /*export let images = [
        // hustle
        "photo-1482440308425-276ad0f28b19",
        // begin coffee mug
        "photo-1489533119213-66a5cd877091",
        // books
        "photo-1512820790803-83ca734da794",
        // like a boss mug
        "photo-1484981138541-3d074aa97716",
        // laptop and coffee
        "photo-1515847049296-a281d6401047",
        // books2
        "photo-1525972385596-02ad3049150b",
        // team1
        "photo-1522071901873-411886a10004",
        // muntain climbing
        "photo-1519309621146-2a47d1f7103a"
    ];*/

    // mountain area images
    const images = [
        // mountain slope with reddish glow, mountains getting lower to the right
        //"/images/backgrounds/mountain1.jpg",

        // really nice outstanding snowy mountain top
        "https://c4.wallpaperflare.com/wallpaper/202/691/681/matterhorn-mountains-nature-landscape-wallpaper-preview.jpg",

        "https://c4.wallpaperflare.com/wallpaper/446/319/706/landscape-mountains-snow-snowy-peak-wallpaper-preview.jpg",

        // CGI wallpaper of watchtower in tree land
        "https://c4.wallpaperflare.com/wallpaper/758/252/42/firewatch-video-games-mountains-nature-wallpaper-preview.jpg",

        // background with birds flying fom trees
        "https://c4.wallpaperflare.com/wallpaper/600/360/964/digital-art-landscape-forest-mountains-wallpaper-preview.jpg",

        "https://c4.wallpaperflare.com/wallpaper/55/157/309/mountains-cliff-peak-doi-inthanon-wallpaper-preview.jpg",

        "https://c4.wallpaperflare.com/wallpaper/333/691/669/rock-formation-on-brown-field-during-daytime-wallpaper-preview.jpg",

        //"https://c4.wallpaperflare.com/wallpaper/578/978/337/landscape-photography-of-mountain-surrounded-by-trees-berchtesgaden-berchtesgaden-wallpaper-preview.jpg",

        //"https://c4.wallpaperflare.com/wallpaper/650/686/462/signage-showing-right-turn-10-wallpaper-preview.jpg",
        "https://c4.wallpaperflare.com/wallpaper/740/445/308/mountains-the-game-people-forest-wallpaper-preview.jpg",
    ];

    //
    // regular variables
    //

    // flag to track download progress of background image
    let loaded = false;

    // in-memory element we download the image to
    let asyncLoadedImage = new Image();

    let imgId = randomImageId();

    // listen to when the image has loaded
    asyncLoadedImage.onload = function()
    {
        // will set the 'loaded' class and transition component to opacity
        markLoaded();
    };

    //
    // derived variables
    //

    // choose randomized image
    $: currentRandomImage = Util.unsplashIdToSrc(imgId, {
        quality, width, height
    });

    // whether to render image or CSS expression
    $: isImage = random
        || content == "random"
        || content.includes("url(")
        ;

    // propname of CSS background property to use
    $: backgroundStylePropname = (isImage)
            ? `background-image`
            : `background`
            ;

    // CSS background style value
    $: backgroundStyle = currentRandomImage && parseContent(content);

    // HTML style value
    $: style = `${backgroundStylePropname}: ${backgroundStyle};`

    //
    // functions
    //

    // request background cycling
    export function next() {
        let curIndex = images.indexOf(imgId);
        if (curIndex >= 0 && curIndex < (images.length-1)) {
            imgId = images[curIndex+1];
        }
        else {
            imgId = images[0];
        }
        console.log(`[Background] cycling background image to: ${imgId}`);
    }

    function markLoaded() {
        loaded = true;
        dispatch("loaded");
    }

    // get the unsplash ID of a random image in our set
    function randomImageId() {
        return images[Math.floor(Math.random() * Math.floor(images.length))];
    }

    // async download background image to in-memory image element
    function downloadImage() {
        asyncLoadedImage.src = currentRandomImage;
    }

    // parse the background content value directive
    function parseContent(cnt) {
        // why does this switch not work?
        /*return switch (cnt) {
            case "random": {
                return `url('${currentRandomImage}')`;
            },
            case "darken": {
                return "rgba(0, 0, 0, 0.9)";
            },
            default: {
                return cnt;
            }
        }*/

        if (cnt == "random") {
            return `url('${currentRandomImage}')`;
        }
        if (cnt == "darken") {
            return "rgba(0, 0, 0, 0.6)";
        }
        // other configs here...
        return cnt;
    }

    // if we show an image background, set the unsplash image source
    // to the in-memory image element. once it is downloaded, the onload handler
    // will fire setting the load status to true, after which the div is
    // rendered with opacity.
    onMount(async () => {
        if (!enable) {
            // do nothing
        }
        else if (isImage) {
            downloadImage();
        }
        else {
            markLoaded();
        }
	});

</script>

{#if enable}
    <div class="background" {style} class:loaded class:parallax/>
    {#if loader}
        <div class="background-loader" style="background: {loaderBackground}" class:loaded />
    {/if}
{/if}